import React, { useCallback, useState, Suspense } from 'react';
import { useTrelloCard } from './use-trello-card';
const TrelloPopperAsync = /*#__PURE__*/React.lazy(() => import( /* webpackChunkName: "@atlaskit-internal_@atlassian/product-search-dialog/extensible/trello/trello-hover-previews/trello-popper" */'./trello-popper').then(({
  TrelloPopper
}) => ({
  default: TrelloPopper
})));
export const HoverPreviewsResultWrapper = ({
  id,
  title,
  prefs,
  meta,
  additionalMeta,
  closed,
  type,
  children,
  isColorBlindModeEnabled,
  isPreviewOnTrelloSearchResultsEnabled,
  screen
}) => {
  const {
    getCard
  } = useTrelloCard();
  const [result, setResult] = useState();
  const onFetchCard = useCallback(async () => {
    const card = await getCard(id);
    if (card) {
      setResult({
        ...card,
        type: 'card',
        id,
        title,
        closed,
        meta,
        additionalMeta,
        screen
      });
    }
  }, [getCard, id, title, closed, meta, screen, additionalMeta]);
  const onFetchBoard = useCallback(() => {
    if (prefs) {
      setResult({
        type: 'board',
        id,
        title,
        prefs,
        meta,
        closed,
        screen
      });
    }
  }, [id, title, prefs, meta, closed, screen]);
  if (!isPreviewOnTrelloSearchResultsEnabled) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  }
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: null
  }, /*#__PURE__*/React.createElement(TrelloPopperAsync, {
    type: type,
    result: result,
    onFetchCard: onFetchCard,
    onFetchBoard: onFetchBoard,
    isColorBlindModeEnabled: isColorBlindModeEnabled,
    screen: screen
  }, children));
};